import {isEmpty as _isEmpty} from "lodash";
import * as React from "react";
import { HabitPrescriptionItemRequest } from "@curefit/gmf-common";
import { ORION_IMG_URL } from "../../../utils/AppConstants";

export interface HabitPlanPDFProps {
    id: string;
    planItem: any;
}

class HabitPlanPDFTemplate extends React.Component<HabitPlanPDFProps> {
    getHabitMarkup(habit: HabitPrescriptionItemRequest) {
        if (typeof habit === "string") {
            if (habit === "FILLER-BIG")
                return <div className={"habits-filler big-filler brandon-bold"}>
                    <div><img src={ORION_IMG_URL + "habits-filler.svg"} /></div>
                    <div>
                        <div className={"filler-text row-1"}>GO WHOLE!</div>
                        <div className={"filler-text row-2"}>OR GO HOME!</div>
                    </div>
                </div>
            else return <div className={"habits-filler small-filler brandon-bold"}>
                <img src={ORION_IMG_URL + "habits-filler.svg"} />
                <div>
                    <div className={"filler-text row-1"}>GO WHOLE!</div>
                    <div className={"filler-text row-2"}>OR GO HOME!</div>
                </div>
            </div>
        } else {
            const habitName = (habit.dailyHabit.displayValue || "").toLowerCase();
            let imgPath = "";
            if (habitName.indexOf("smoking") !== -1) {
                imgPath = ORION_IMG_URL + "reduce-smoking.svg";
            } else if (habitName.indexOf("water") !== -1) {
                imgPath = ORION_IMG_URL + "increase-water-intake.svg";
            } else if (habitName.indexOf("alcohol") !== -1) {
                imgPath = "/images/reduce-alcohol.svg";
            }
            if (imgPath.length) {
                return <div>
                    <img src={imgPath} />
                    <div>{habitName}</div>
                </div>
            }
        }
    }
    render() {
        let id = this.props.id;
        let planItem = this.props.planItem;
        let itemToIterate = planItem[id];
        return (
            <div id={id} className="prescription-grid-row external-row">
                <div className="prescription-card-content">
                    <h4 className="brandon-bold">HABITS</h4>
                    <div id={`${id}-subsection`} className="prescription-description">
                        {itemToIterate.habitItems.map((habitItem: HabitPrescriptionItemRequest, index: number) => {
                            if (!_isEmpty(habitItem)) {
                                let cssClass = habitItem === "FILLER-BIG" ? "FILLER_BIG" : "";
                                return <div className={`habit-item ${cssClass}`} key={index}>
                                    {
                                        this.getHabitMarkup(habitItem)
                                    }
                                </div>
                            }
                        })}
                    </div>
                </div>
            </div>
        )
    }
}

export default HabitPlanPDFTemplate;
